import { Description, Icon, IconToggleButton } from "@evergis/ui";

import React, { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ResourceViewType } from "../../../../../Catalog/components/ViewType/types";
import { FieldValue } from "../../../../styled";
import { JSONAttributeValue } from "../../types";
import { AttachmentsGrid } from "./AttachmentsGrid";
import { AttachmentsList } from "./AttachmentsList";
import {
  AttachmentsContainer,
  AttachmentsLabel,
  AttachmentsHeader,
  AttachmentsViewControls,
  AttachmentsContent,
  AttachmentsChip,
} from "./styled";

export interface AttachmentsAttributeProps {
  value?: JSONAttributeValue[];
  label: React.ReactNode;
  isEdit?: boolean;
  onChange?: (value?: JSONAttributeValue[]) => void;
  storeAttributes?: VoidFunction;
}

export const AttachmentsAttribute: FC<AttachmentsAttributeProps> = ({
  value,
  label,
  isEdit = false,
  onChange,
  storeAttributes,
}) => {
  const { t } = useTranslation();
  const [viewType, setViewType] = useState(ResourceViewType.Grid);

  useEffect(() => {
    if (storeAttributes) {
      storeAttributes();
    }
  }, [value, storeAttributes]);

  if (!value && !isEdit) {
    return <FieldValue field={label} value={"-"} />;
  }

  return (
    <AttachmentsContainer isEdit={isEdit}>
      <AttachmentsHeader>
        <AttachmentsLabel>
          <Description>{label}</Description>
          {value && <AttachmentsChip text={String(value.length)} />}
        </AttachmentsLabel>
        <AttachmentsViewControls>
          <IconToggleButton
            onClick={() => setViewType(ResourceViewType.Grid)}
            isSelected={viewType === ResourceViewType.Grid}
            title={t("tileView", { ns: "catalog" })}
          >
            <Icon kind={"grid"} />
          </IconToggleButton>
          <IconToggleButton
            onClick={() => setViewType(ResourceViewType.Table)}
            isSelected={viewType === ResourceViewType.Table}
            title={t("tableView", { ns: "catalog" })}
          >
            <Icon kind={"list"} />
          </IconToggleButton>
        </AttachmentsViewControls>
      </AttachmentsHeader>
      <AttachmentsContent>
        {viewType === ResourceViewType.Grid && <AttachmentsGrid isEdit={isEdit} items={value} onChange={onChange} />}
        {viewType === ResourceViewType.Table && <AttachmentsList isEdit={isEdit} items={value} onChange={onChange} />}
      </AttachmentsContent>
    </AttachmentsContainer>
  );
};
